export class SixFailure {
    static CANNOT_MOVE_YET = () => $localize `You cannot move yet. Pick a space where you will put a new piece.`;
    static MUST_CUT = () => $localize `Several groups are of the same size, you must pick the one to keep.`;
    static CANNOT_CHOOSE_TO_KEEP = () => $localize `You cannot choose which part to keep when one is smaller than the other.`;
    static CAN_NO_LONGER_DROP = () => $localize `You cannot put new pieces anymore. Pick a piece to move.`;
    static MUST_CAPTURE_BIGGEST_GROUPS = () => $localize `You must choose one of the biggest groups to keep it.`;
    static CANNOT_KEEP_EMPTY_COORD = () => $localize `You cannot pick an empty space. Pick one of the biggest groups.`;
    static MUST_DROP_NEXT_TO_OTHER_PIECE = () => $localize `You must put this piece next to another piece.`;
}
